import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { pillarArticles } from '@/mocks/pillarArticles';

interface GuideItem {
  title: string;
  desc: string;
}

export default function PillarSection() {
  const { t } = useTranslation();

  const items = t('guides.items', { returnObjects: true }) as GuideItem[];

  return (
    <section id="guides" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            {t('guides.sectionTitle')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            {t('guides.sectionSubtitle')}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {pillarArticles.map((article, i) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors flex flex-col"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={items[i]?.title}
                  title={items[i]?.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${article.icon} text-base`}></i>
                </span>
                <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {items[i]?.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {items[i]?.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-xs md:text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                  {t('guides.readMore')}
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}